import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Cryptocurrency04 = function Cryptocurrency04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m2 2 2 2m18-2-2 2m2 18-2-2M2 22l2-2m-2-4h1.5M8 2v1.5M22 8h-1.5M16 22v-1.5m2-4.5h3.5M16 2v4M2 8h4m2 14v-4m3.4343-10.4343-3.8686 3.8686c-.198.198-.297.297-.3341.4112a.5.5 0 0 0 0 .309c.037.1142.136.2132.334.4112l3.8687 3.8686c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341l3.8686-3.8686c.198-.198.297-.297.3341-.4112a.5.5 0 0 0 0-.309c-.0371-.1142-.1361-.2132-.3341-.4112l-3.8686-3.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1142.037-.2132.136-.4112.334"
    })
  }));
};
export default Cryptocurrency04;